import React from "react";
import { Modal } from "antd";
import ReactDOM from "react-dom";
const _ = require("lodash");

class HelpModal extends React.Component {
  state = { loading: true };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.url !== this.props.url) {
      this.setState({ loading: true });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 5000);
    }
  }

  render() {
    const iframeStyle = {
      display: "none"
    };
    return (
      <Modal
        title="Arro Help"
        wrapClassName="vertical-center-modal"
        visible={this.props.show}
        width={"80vw"}
        onCancel={this.props.onCancel}
        footer={null}
      >
        <div style={{ height: "65vh" }}>
          {this.state.loading ? (
            <div className="d-flex justify-content-center">
              <i className={`fa fa-circle-o-notch fa-spin fa-3x fa-fw`} />
            </div>
          ) : (
            undefined
          )}
          {this.props.url ? (
            <iframe
              title="arro help"
              src={`${this.props.url}?frameable=true`}
              frameBorder={"0"}
              width={"100%"}
              height={"98%"}
              style={{ display: this.state.loading ? "none" : "inline" }}
            />
          ) : (
            undefined
          )}
        </div>
      </Modal>
    );
  }
}

export default HelpModal;



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/HelpMenu/helpModal.js